module.exports = __webpack_public_path__ + "img/blue_002.cb1bc328.png";